/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import CircularLoading from "../../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Row,
  Col,
  Button,
  Container,
  Badge,
  Progress
} from "reactstrap";
import { FirebaseContext } from "common";

const StaffProfile = () => {
  const { api } = useContext(FirebaseContext);
  const { updateProfile, updateWebProfileImage } = api;
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [data, setData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    loginType: null,
    userType: "",
    profile_image: null,
    practiceNumber: "",
    practiceName: "",
    practiceLicenseNumber: "",
    practiceType: false,
  });

  // Mock performance data (would come from API in real app)
  const [performanceData] = useState({
    tasksCompleted: 42,
    tasksThisWeek: 12,
    clientSatisfaction: 4.7,
    responseTime: "2.4h",
    performanceScore: 88
  });

  // Mock upcoming schedule
  const [upcomingSchedule] = useState([
    
  ]);

  useEffect(() => {
    if (auth.info && auth.info.profile) {
      setData({
        firstName:
          !auth.info.profile.firstName || auth.info.profile.firstName === " "
            ? ""
            : auth.info.profile.firstName,
        lastName:
          !auth.info.profile.lastName || auth.info.profile.lastName === " "
            ? ""
            : auth.info.profile.lastName,
        email:
          !auth.info.profile.email || auth.info.profile.email === " "
            ? ""
            : auth.info.profile.email,
        mobile:
          !auth.info.profile.mobile || auth.info.profile.mobile === " "
            ? ""
            : auth.info.profile.mobile,
        loginType: auth.info.profile.loginType ? "social" : "email",
        userType: auth.info.profile.userType,
        practiceNumber: auth.info.profile.practiceNumber,
        practiceName: auth.info.profile.practiceName,
        practiceLicenseNumber: auth.info.profile.practiceLicenseNumber,
        practiceType: auth.info.profile.practiceType,
        uid: auth.info.uid,
        profile_image:
          !auth.info.profile.profile_image ||
          auth.info.profile.profile_image === " "
            ? ""
            : auth.info.profile.profile_image,
      });
    }
  }, [auth.info]);
  
  const [fileState, setFileState] = React.useState(null);

  const handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      setFileState(file);
      setData({ ...data, profile_image: reader.result });
    };
    dispatch(updateWebProfileImage(auth.info, file));
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  // Function to get user type badge color
  const getUserTypeBadgeColor = (userType) => {
    switch(userType) {
      case 'admin': return 'primary';
      case 'broker': return 'success';
      case 'landlord': return 'warning';
      default: return 'secondary';
    }
  };

  return auth.loading ? (
    <CircularLoading />
  ) : (
    <Container fluid style={{ padding: "20px", backgroundColor: "#f5f7f9", minHeight: "100vh" }}>
      <Row>
        <Col md="8" className="mx-auto">
          {/* Profile Header Card */}
          <Card className="card-profile" style={{ 
            borderRadius: "16px", 
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
            overflow: "hidden",
            marginBottom: "30px",
            border: "none"
          }}>
            <div style={{
              height: "140px",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              position: "relative"
            }}>
              <div style={{
                position: "absolute",
                bottom: "-70px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "140px",
                height: "140px",
                borderRadius: "50%",
                border: "4px solid white",
                backgroundColor: "white",
                boxShadow: "0 6px 20px rgba(0, 0, 0, 0.15)",
                overflow: "hidden",
                cursor: "pointer",
                transition: "all 0.3s ease"
              }} className="profile-picture-container">
                <img
                  src={data.profile_image || "https://via.placeholder.com/140x140?text=Upload+Photo"}
                  style={{ 
                    width: "100%", 
                    height: "100%", 
                    objectFit: "cover" 
                  }}
                  alt="Profile"
                />
                <div style={{
                  position: "absolute",
                  bottom: "0",
                  left: "0",
                  right: "0",
                  backgroundColor: "rgba(0,0,0,0.6)",
                  color: "white",
                  textAlign: "center",
                  padding: "5px",
                  fontSize: "12px",
                  opacity: "0",
                  transition: "opacity 0.3s ease"
                }} className="upload-text">
                  Change Photo
                </div>
                <input 
                  type="file" 
                  onChange={(e) => handleImageChange(e)} 
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    opacity: "0",
                    cursor: "pointer"
                  }}
                  accept="image/*"
                />
              </div>
            </div>

            <CardBody style={{ padding: "30px", marginTop: "70px" }}>
              <div className="text-center">
                <h3 className="mb-1" style={{ fontWeight: "700", color: "#2d3748", fontSize: "28px" }}>
                  {data.firstName} {data.lastName}
                </h3>
                <div className="mb-3">
                  <Badge color={getUserTypeBadgeColor(data.userType)} pill style={{ 
                    fontSize: "14px", 
                    padding: "8px 16px",
                    fontWeight: "600",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px"
                  }}>
                    {data.userType}
                  </Badge>
                </div>
                
                <Row className="justify-content-center">
                  <Col lg="10">
                    <Row>
                      <Col md="6" className="mb-3">
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <i className="now-ui-icons ui-1_email-85 mr-2" style={{ color: "#667eea", fontSize: "18px" }}></i>
                          <span style={{ color: "#4a5568", fontWeight: "500" }}>{data.email || "Not provided"}</span>
                        </div>
                      </Col>
                      <Col md="6" className="mb-3">
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <i className="now-ui-icons tech_mobile mr-2" style={{ color: "#667eea", fontSize: "18px" }}></i>
                          <span style={{ color: "#4a5568", fontWeight: "500" }}>{data.mobile || "Not provided"}</span>
                        </div>
                      </Col>
                    </Row>
                    
                    {data.practiceName && (
                      <div className="mb-2">
                        <i className="now-ui-icons business_bank mr-2" style={{ color: "#667eea", fontSize: "18px" }}></i>
                        <span style={{ color: "#4a5568", fontWeight: "500" }}>{data.practiceName}</span>
                      </div>
                    )}
                    
                    {data.practiceNumber && (
                      <div className="mb-2">
                        <i className="now-ui-icons business_badge mr-2" style={{ color: "#667eea", fontSize: "18px" }}></i>
                        <span style={{ color: "#4a5568", fontWeight: "500" }}>License: {data.practiceNumber}</span>
                      </div>
                    )}
                    
                    {data.practiceType && (
                      <div>
                        <i className="now-ui-icons education_agenda-bookmark mr-2" style={{ color: "#667eea", fontSize: "18px" }}></i>
                        <span style={{ color: "#4a5568", fontWeight: "500" }}>{data.practiceType}</span>
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            </CardBody>
            
            <CardFooter style={{ 
              backgroundColor: "#f8f9fa", 
              borderTop: "1px solid #edf2f7",
              padding: "20px 30px"
            }}>
              <div className="button-container text-center">
                <Button
                  className="btn-icon btn-round mr-2"
                  color="primary"
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                  style={{ 
                    borderRadius: "50%", 
                    width: "44px", 
                    height: "44px",
                    backgroundColor: "#4267B2",
                    border: "none",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  <i className="fab fa-facebook-f" />
                </Button>
                <Button
                  className="btn-icon btn-round mr-2"
                  color="info"
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                  style={{ 
                    borderRadius: "50%", 
                    width: "44px", 
                    height: "44px",
                    backgroundColor: "#1DA1F2",
                    border: "none",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  <i className="fab fa-twitter" />
                </Button>
                <Button
                  className="btn-icon btn-round"
                  color="danger"
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                  style={{ 
                    borderRadius: "50%", 
                    width: "44px", 
                    height: "44px",
                    backgroundColor: "#DB4437",
                    border: "none",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  <i className="fab fa-google" />
                </Button>
              </div>
            </CardFooter>
          </Card>
        </Col>
      </Row>

      

      <style>
        {`
          .profile-picture-container:hover .upload-text {
            opacity: 1 !important;
          }
          .profile-picture-container:hover {
            transform: translateX(-50%) scale(1.05) !important;
          }
          .card:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1) !important;
          }
          .card {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
        `}
      </style>
    </Container>
  );
};

export default StaffProfile;